var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.375 2.1875H2.625C2.38338 2.1875 2.1875 2.38338 2.1875 2.625V11.375C2.1875 11.6166 2.38338 11.8125 2.625 11.8125H11.375C11.6166 11.8125 11.8125 11.6166 11.8125 11.375V2.625C11.8125 2.38338 11.6166 2.1875 11.375 2.1875Z",
    stroke: "#101010",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 8.74999L9.49686 6.43435C9.41481 6.35231 9.30353 6.30621 9.1875 6.30621C9.07147 6.30621 8.96019 6.35231 8.87814 6.43435L6.43436 8.87814C6.35231 8.96018 6.24103 9.00628 6.125 9.00628C6.00897 9.00628 5.89769 8.96018 5.81564 8.87814L4.68436 7.74685C4.60231 7.66481 4.49103 7.61871 4.375 7.61871C4.25897 7.61871 4.14769 7.66481 4.06564 7.74685L2.1875 9.625",
    stroke: "#101010",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46875 5.90625C5.952 5.90625 6.34375 5.5145 6.34375 5.03125C6.34375 4.548 5.952 4.15625 5.46875 4.15625C4.9855 4.15625 4.59375 4.548 4.59375 5.03125C4.59375 5.5145 4.9855 5.90625 5.46875 5.90625Z",
    fill: "#101010"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.3f3f3dfb9c31a52d71dcf3cf641e3573.svg";
export { ForwardRef as ReactComponent };